import { render, staticRenderFns } from "./VATRateEdit.vue?vue&type=template&id=6d0b0a9e&"
import script from "./VATRateEdit.vue?vue&type=script&lang=js&"
export * from "./VATRateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports